<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <!-- Patient details section -->
                <div class="col-md-12 mt-2">
                    <div class="row">
                        <div class="col-md-8">
                            <p>
                                <strong class="fw-bold">Nombre:</strong> {{ paciente?.nombre || 'No aplica' }} |
                                <strong class="fw-bold">Fecha de Nacimiento:</strong> {{ paciente?.fecha_nacimiento ?
                                formatDate(paciente.fecha_nacimiento) : 'No aplica' }} |
                                <strong class="fw-bold">Género:</strong> {{ paciente?.genero || 'No aplica' }} <br>
                                <strong class="fw-bold">Teléfono:</strong> {{ paciente?.telefono || 'No aplica' }} |
                                <strong class="fw-bold">Email:</strong> {{ paciente?.email || 'No aplica' }} |
                                <strong class="fw-bold">Dirección:</strong> {{ paciente?.direccion || 'No aplica' }} |
                                <strong class="fw-bold">Subsecuencia:</strong> 
                                {{ paciente?.subsecuencia === 'Primera Vez' ? 'Paciente de primera vez' : 'El paciente es subsecuente' }}
                            </p>
                        </div>
                        <div class="col-md-4 text-end">
                            <p>
                                <strong class="fw-bold">Fecha de Nota:</strong> {{ new
                                Date().toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric'
                                }) }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Form section -->
                <div class="col-md-12 mb-3">
                    <div class="card">
                        <div class="card-body">
                            <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son obligatorios.</p>
                            <div class="row">
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Tipo de Nota <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="nuevaNota.tipo_nota" required>
                                        <option disabled value="">Seleccione un tipo</option>
                                        <!-- <option value="Consulta Externa">Consulta Externa</option> -->
                                        <!-- <option value="Urgencias">Urgencias</option> -->
                                        <option value="Evolución">Evolución</option>
                                        <!-- <option value="Interconsulta">Interconsulta</option> -->
                                        <option value="Nota de Egreso">Nota de Egreso</option>
                                        <option value="Valoración Preoperatoria">Valoración Preoperatoria</option>
                                        <option value="Nota de Defunción y Egreso de Paciente Fallecido">Nota de Defunción y Egreso de Paciente Fallecido</option>
                                    </select>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Motivo de la Consulta <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" v-model.trim="nuevaNota.motivo_consulta" maxlength="250" required />
                                </div>


                                <div class="col-md-12">
                                    <SignosVitales 
                                        :consulta_id="notaMedicaConsultas.id" 
                                        @enviaSignos="handleSignosVitales" 
                                    />
                                </div>

                                <div class="col-md-12" v-html="nuevaNota.ficha_identificacion"></div>
                                <div class="col-md-12" v-html="nuevaNota.signos_vitales"></div>

                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Observaciones y contenido general</label>
                                    <p class="text-muted">Complementa los datos de la nota médica aquí, puedes editar libremente y agregar el texto que desees.</p>
                                    <vue-editor v-model="nuevaNota.observaciones" placeholder="Ingresa el contenido de la nota médica" :editorToolbar="customToolbar"></vue-editor>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Diagnóstico <span class="text-danger">*</span></label>
                                    <multiselect
                                        v-model="selectedDiagnostico"
                                        :options="diagnosticoResults"
                                        label="nombre_busqueda"
                                        track-by="catalog_key"
                                        placeholder="Ingresa el diagnóstico"
                                        @search-change="searchDiagnosticos"
                                        @select="selectDiagnostico"
                                        :loading="isLoadingDiagnostico"
                                        :clear-on-select="true"
                                        :close-on-select="true"
                                        :allow-empty="false"
                                    >
                                    </multiselect>
                                    <small class="text-muted d-block mb-2">Anterior: {{ nuevaNota?.diagnostico || 'No disponible' }}</small>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Exploración Física</label>
                                    <textarea class="form-control" v-model.trim="nuevaNota.exploracion_fisica" maxlength="1000" rows="10"></textarea>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Estudios Solicitados</label>
                                    <textarea class="form-control" v-model.trim="nuevaNota.estudios_solicitados" maxlength="1000" rows="10"></textarea>
                                </div>
                                
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Evolución del Paciente</label>
                                    <textarea class="form-control" v-model.trim="nuevaNota.evolucion_paciente" maxlength="1000" rows="10"></textarea>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Tratamiento</label>
                                    <textarea class="form-control" v-model.trim="nuevaNota.tratamiento" maxlength="1000" rows="10"></textarea>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Pronóstico</label>
                                    <textarea class="form-control" v-model.trim="nuevaNota.pronostico" maxlength="250" rows="10"></textarea>
                                </div>
                               
                                <div class="col-md-12 text-center">
                                    <vs-button type="submit" color="rgb(59,222,200)" gradient block @click="crearNota('finalizada')">
                                        💾 Guardar  y finalizar nota médica
                                    </vs-button>
                                    <a class="smallText text-center" @click="crearNota('guardada')"
                                    href="#"> Pre-guardar nota para más tarde</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { VueEditor } from 'vue2-editor'; // Import VueEditor
    import Multiselect from 'vue-multiselect'; // Import Multiselect
    import SignosVitales from './SignosVitales.vue';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "NotaMedica",
        components: {
            VueEditor, // Register VueEditor
            Multiselect, // Register Multiselect
            SignosVitales // Register SignosVitales
        },
        props: {
            currentUser: {
                type: Object,
                required: true
            },
            paciente: {
                type: Object,
                required: true
            },
            notaMedicaConsultas: {
                type: [Array, Object], // Acepta tanto Array como Object
                required: true
            }
        },
        data() {
            return {
                notaMedica: null,
                observacionesOrigen: [
                            `<p><strong>Ficha de Identificación:<br></strong>Nombre: ${this.paciente?.nombre || 'No aplica'} | Fecha de Nacimiento: ${this.paciente?.fecha_nacimiento ? this.formatDate(this.paciente.fecha_nacimiento) : 'No aplica'} (${this.calculateAge(this.paciente?.fecha_nacimiento)}) | Género: ${this.paciente?.genero || 'No aplica'}\n | Teléfono: ${this.paciente?.telefono || 'No aplica'} | Email: ${this.paciente?.email || 'No aplica'} | Dirección: ${this.paciente?.direccion || 'No aplica'}</p><p><strong>Tpo consulta:<br></strong>${this.paciente?.subsecuencia === 'Primera Vez' ? 'Primera vez' : 'Subsecuente'}<br>` + `\n`
                        ].join(' | ') + 
                        `</p>`,
                nuevaNota: {
                    tipo_nota: '',
                    motivo_consulta: this.notaMedicaConsultas?.motivo || '',
                    exploracion_fisica: '',
                    estudios_solicitados: '',
                    diagnostico: '',
                    pronostico: '',
                    evolucion_paciente: '',
                    tratamiento: '',
                    signos:'',
                    ficha_identificacion:  [`<p><strong>Ficha de Identificación:<br></strong>Nombre: ${this.paciente?.nombre || 'No aplica'} | Fecha de Nacimiento: ${this.paciente?.fecha_nacimiento ? this.formatDate(this.paciente.fecha_nacimiento) : 'No aplica'} (${this.calculateAge(this.paciente?.fecha_nacimiento)}) | Género: ${this.paciente?.genero || 'No aplica'}\n | Teléfono: ${this.paciente?.telefono || 'No aplica'} | Email: ${this.paciente?.email || 'No aplica'} | Dirección: ${this.paciente?.direccion || 'No aplica'}</p><p><strong>Tpo consulta:<br></strong>${this.paciente?.subsecuencia === 'Primera Vez' ? 'Primera vez' : 'Subsecuente'}<br>` + `\n`
                        ].join(' | ') + 
                        `</p>`,
                    signos_vitales: '',
                    observaciones: '',
                },
                customToolbar: [
                    [{ 'header': [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline'],
                    [{ 'align': [] }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ], // Define custom toolbar for VueEditor
                selectedDiagnostico: null,
                diagnosticoResults: [],
                isLoadingDiagnostico: false,
                signos: '' // Initialize signos as an empty string
            };
        },
        async mounted() {
            if (this.notaMedicaConsultas.nota_medica_id !== 0) {
                await this.fetchNotaMedica();
            }

        },
        methods: {
            async fetchNotaMedica() {
                this.notaMedica = null; // Reset notaMedica before fetching 
                try {
                    const response = await axios.get(`${API}/nota_medica/${this.notaMedicaConsultas.nota_medica_id}`);
                    if (response.data.status === 'success') {
                        this.notaMedica = response.data.data;
                        console.log('Nota médica cargada:', this.notaMedica);
                        if (this.notaMedica) {
                            this.nuevaNota = {
                                tipo_nota: this.notaMedica.tipo_nota || '',
                                motivo_consulta: this.notaMedica.motivo_consulta || '',
                                exploracion_fisica: this.notaMedica.exploracion_fisica || '',
                                estudios_solicitados: this.notaMedica.estudios_solicitados || '',
                                diagnostico: this.notaMedica.diagnostico || '',
                                pronostico: this.notaMedica.pronostico || '',
                                evolucion_paciente: this.notaMedica.evolucion_paciente || '',
                                tratamiento: this.notaMedica.tratamiento || '',
                                ficha_identificacion: this.notaMedica.ficha_identificacion || '',
                                signos_vitales: this.notaMedica.signos_vitales || '',
                                observaciones: this.notaMedica.observaciones || ''
                            };
                        }
                    } else {
                        this.$emit('error', response.data.message);
                    }
                } catch (error) {
                    console.error(error);
                    this.$emit('error', 'Error al cargar la nota médica.');
                }
            },
            handleSignosVitales(response){
                console.log('Signos vitales recibidos:', response);
                this.nuevaNota.signos_vitales = `
                    <p><strong>Signos Vitales:<br></strong>` +
                    `Presión Arterial: ${response.presion_arterial || 'No disponible'}` +
                    `, Temperatura: ${response.temperatura || 'No disponible'} °C` +
                    `, Frecuencia Cardiaca: ${response.frecuencia_cardiaca || 'No disponible'} bpm` +
                    `, Frecuencia Respiratoria: ${response.frecuencia_respiratoria || 'No disponible'} rpm` +
                    `, Peso: ${response.peso || 'No disponible'} kg` +
                    `, Estatura: ${response.estatura || 'No disponible'} m` +
                    `, IMC: ${response.imc || 'No calculado'}` +
                    `, Saturación de Oxígeno: ${response.saturacion_oxigeno || 'No calculado'} %` +
                    `, Glucosa: ${response.glucosa || 'No calculado'}` +
                    `\n</p>`;

                // this.nuevaNota.observaciones = this.observacionesOrigen + this.signos;
                
            },
            async crearNota(estatus_nota) {
                if (
                    !this.vEmpty(this.nuevaNota.tipo_nota, 'Tipo de Nota') ||
                    !this.vEmpty(this.nuevaNota.motivo_consulta, 'Motivo de la Consulta') ||
                    !this.vEmpty(this.nuevaNota.exploracion_fisica, 'Exploración Física') ||
                    !this.vEmpty(this.nuevaNota.estudios_solicitados, 'Estudios Solicitados') ||
                    !this.vEmpty(this.nuevaNota.diagnostico, 'Diagnóstico') ||
                    !this.vEmpty(this.nuevaNota.pronostico, 'Pronóstico') ||
                    !this.vEmpty(this.nuevaNota.evolucion_paciente, 'Evolución del Paciente') ||
                    !this.vEmpty(this.nuevaNota.tratamiento, 'Tratamiento') ||
                    !this.vEmpty(this.nuevaNota.observaciones, 'Observaciones y contenido general')
                ) {
                    return;
                }
                

                try {
                    const notaData = this.notaMedicaConsultas.estatus_nota === 'no disponible' 
                        ? {
                            ...this.nuevaNota,
                            consulta_id: this.notaMedicaConsultas?.id || null,
                            personal_medico_id: this.currentUser.mainId,
                            estatus_nota: estatus_nota
                        }
                        : {
                            ...this.nuevaNota,
                            consulta_id: this.notaMedicaConsultas?.id || null,
                            personal_medico_id: this.currentUser.mainId,
                            estatus_nota: estatus_nota,
                            nota_medica_id: this.notaMedicaConsultas.nota_medica_id
                        };

                    console.log('Nota médica a crear:', notaData);
                    console.log('tipo nota:', this.notaMedicaConsultas);
             
                    const endpoint = this.notaMedicaConsultas.estatus_nota === 'no disponible' 
                        ? `${API}/crear_nota_medica` 
                        : `${API}/actualizar_nota_medica`;
                    const response = await axios.post(endpoint, notaData);

                    if (response.data.status === 'success') {
                        this.notify('success', 'Nota médica creada exitosamente');


                        if(estatus_nota=='finalizada'){

                                await this.callAudit(this.currentUser.mainId,
                                "ACTUALIZAR",
                                "notas_medicas",
                                this.notaMedicaConsultas.nota_medica_id,
                                'Finaliza la nota médica',
                                );   

                        }else{

                            await this.callAudit(this.currentUser.mainId,
                                this.notaMedicaConsultas.estatus_nota === 'no disponible' 
                                ? `CREAR` 
                                : `ACTUALIZAR`,
                                "notas_medicas",
                                this.notaMedicaConsultas.estatus_nota === 'no disponible' 
                                ? this.notaMedicaConsultas?.id 
                                : this.notaMedicaConsultas.nota_medica_id,
                                this.notaMedicaConsultas.estatus_nota === 'no disponible' 
                                ? "Creación de nota médica"
                                : "Actualización de nota médica", 
                                );   
                        }


                        this.resetForm();
                        this.$emit('terminaNotaMedica');
                    }
                } catch (error) {
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            resetForm() {
                this.nuevaNota = {
                    tipo_nota: '',
                    motivo_consulta: '',
                    exploracion_fisica: '',
                    estudios_solicitados: '',
                    diagnostico: '',
                    pronostico: '',
                    evolucion_paciente: '',
                    tratamiento: '',
                    observaciones: ''
                };
            },
            vEmpty(value, fieldName) {
                if (!value || value.trim() === '') {
                    this.notify('error', `El campo "${fieldName}" es obligatorio.`);
                    return false;
                }
                return true;
            },
            formatDate(date) {
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return new Date(date).toLocaleDateString('es-ES', options);
            },
            async searchDiagnosticos(query) {
                if (query.trim() === '') {
                    this.diagnosticoResults = [];
                    return;
                }
                this.isLoadingDiagnostico = true;
                try {
                    const response = await axios.post(`${API}/busqueda_cie10`, { searchValue: query });
                    this.diagnosticoResults = response.data;
                } catch (error) {
                    console.error(error);
                    this.notify('error', `Error: ${error.message}`);
                } finally {
                    this.isLoadingDiagnostico = false;
                }
            },
            selectDiagnostico(diagnostico) {
                this.nuevaNota.diagnostico = diagnostico.nombre_busqueda;
            },
            calculateAge(dateOfBirth) {
                if (!dateOfBirth) return 'No calculado';
                const birthDate = new Date(dateOfBirth);
                const today = new Date();
                let age = today.getFullYear() - birthDate.getFullYear();
                const monthDiff = today.getMonth() - birthDate.getMonth();
                if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                    age--;
                }
                return `${age} años`;
            }
        }
    };
</script>

<style>
    /* Add any necessary styles here */
</style>
